import { BaseEntity } from './base-entity';
import { QuestionType } from './question-type';
import { QuestionAnswer } from './question-answer';
import { AssessmentFactorSelection } from './assessment-factor-selection';

export class AssessmentMemberAnswer extends BaseEntity {
  comments: string;
  factors: Array<AssessmentFactorSelection>;
  impact: number;
  impactWeight: number;
  parent: BaseEntity;
  position: number;
  probability: number;
  probabilityWeight: number;
  questionAnswer: QuestionAnswer;
  rank: number;
  requireCommentForNA: boolean;
  skip: boolean;
  type: QuestionType;

  // UI use
  isEditing: boolean;
}
